import { ArticleHeading2, LinkButton, useDeviceType } from '@cian/ui-kit';
import cn from 'clsx';

import * as styles from './DailyrentBanner.css';

const DAILYRENT_PROMO_CODE = 'VDOROGU26';

export interface IDailyrentBannerProps {
  /** Ссылка кнопки на выдачу посуточной аренды */
  url: string;
  onClick?(): void;
}

/**
 * Баннер рекламной кампании посуточной аренды для статей журнала
 */
export const DailyrentBanner: React.FC<IDailyrentBannerProps> = ({ url, onClick }) => {
  const device = useDeviceType();

  return (
    <div className={cn(styles['container'], device === 'phone' && styles['phone'])} data-name="DailyrentBanner">
      <div className={styles['text-block']}>
        <ArticleHeading2 color="text-inverted-default">Устройте себе бархатный отпуск</ArticleHeading2>
        <LinkButton theme="inverted" size="M" href={url} target="_blank" rel="noopener" onClick={onClick}>
          Отдохнуть осенью
        </LinkButton>
      </div>
      <div className={styles['picture']}>
        <div className={styles['promo']}>
          <span className={styles['promo-code']}>{DAILYRENT_PROMO_CODE}</span>
        </div>
      </div>
    </div>
  );
};
